import { gql, useMutation } from '@apollo/client';

import { GET_CONSULTANT_NUMBERS } from 'src/hooks/consultant-numbers/get-consultant-numbers.hook';

import { GET_DATEV_NUMBER_BY_ID } from './get-datev-number-by-id.hook';
import { GET_DATEV_NUMBERS } from './get-datev-numbers.hook';

export const DELETE_DATEV_NUMBER_BY_ID = gql`
  mutation deleteDatevNumberById($datevNumberId: String!) {
    deleteDatevNumberById(datevNumberId: $datevNumberId) {
      _id
    }
  }
`;

export const useDeleteDatevNumberById = ({ onSuccess }: { onSuccess: () => void }) => {
  const [deleteDatevNumber] = useMutation(DELETE_DATEV_NUMBER_BY_ID, {
    onCompleted: onSuccess,
    refetchQueries: [GET_DATEV_NUMBER_BY_ID, GET_DATEV_NUMBERS, GET_CONSULTANT_NUMBERS],
  });

  return deleteDatevNumber;
};
